import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "hidden-sound",
  ref: "alertSound",
  controls: "",
  src: "/assets/ccs_alert.mp3"
}
const _hoisted_2 = {
  class: "hidden-sound",
  ref: "timerSound",
  controls: "",
  src: "/assets/ccs_timer.mp3"
}
const _hoisted_3 = { class: "d-flex align-center justify-center mb-8" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "pa-2" }
const _hoisted_7 = { class: "my-4" }
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = { class: "mx-4" }
const _hoisted_10 = { class: "my-4" }
const _hoisted_11 = { class: "my-4 d-flex" }
const _hoisted_12 = { class: "my-4 d-flex" }
const _hoisted_13 = { class: "my-4 d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_nap_sensor_card = _resolveComponent("nap-sensor-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("audio", _hoisted_1, null, 512),
    _createElementVNode("audio", _hoisted_2, null, 512),
    _cache[12] || (_cache[12] = _createElementVNode("div", null, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.nap)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "mb-1" }, "CCS Sensor", -1)),
            _createElementVNode("a", {
              href: `/nap/${_ctx.nap.napId}/detail`,
              class: "text-primary"
            }, "詳細画面へ", 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        class: "mr-8",
        color: "primary",
        variant: "flat",
        rounded: "",
        onClick: _ctx.addInvervalCheck
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("チェック追加 ", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_v_switch, {
        class: "mr-8",
        modelValue: _ctx.isAlertOn,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isAlertOn) = $event)),
        inset: "",
        color: "primary",
        label: "アラート音",
        density: "compact",
        "hide-details": ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_switch, {
        class: "mr-8",
        modelValue: _ctx.isIntervalCheckOn,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isIntervalCheckOn) = $event)),
        inset: "",
        color: "primary",
        label: `定刻チェック (${_ctx.intervalLabel})`,
        density: "compact",
        "hide-details": ""
      }, null, 8, ["modelValue", "label"])
    ]),
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "my-8"
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensorData, (data, i) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            cols: "12",
            md: "2",
            lg: "2",
            xl: "2",
            key: i
          }, {
            default: _withCtx(() => [
              _createVNode(_component_nap_sensor_card, {
                sensorData: data,
                updatingChildId: _ctx.updatingChildId,
                alertingChildrenIds: _ctx.alertingChildrenIds,
                onSleepIn: ($event: any) => (_ctx.sleepIn(data)),
                onGetUp: ($event: any) => (_ctx.getUp(data)),
                onStopAlert: _ctx.stopAlert
              }, null, 8, ["sensorData", "updatingChildId", "alertingChildrenIds", "onSleepIn", "onGetUp", "onStopAlert"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      "model-value": _ctx.intervalCheckTimes && _ctx.intervalCheckTimes.length > 0,
      "max-width": "540",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("定刻チェック", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[7] || (_cache[7] = _createElementVNode("div", null, "時刻", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatTime(_ctx.intervalCheckTimes[0])), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_v_select, {
                  variant: "outlined",
                  label: "申請者",
                  items: _ctx.staffOptions,
                  "item-value": "userId",
                  "item-title": "name",
                  modelValue: _ctx.recorderId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.recorderId) = $event))
                }, null, 8, ["items", "modelValue"])
              ]),
              _createElementVNode("div", null, [
                (_ctx.isConfirming)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary",
                      class: "my-4"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_btn, {
                  color: "gray",
                  variant: "flat",
                  large: "",
                  onClick: _ctx.clearIntervalCheck
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("閉じる", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  large: "",
                  onClick: _ctx.confirmIntervalCheck,
                  disabled: _ctx.isConfirming || !_ctx.recorderId
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("確認", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.initialDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.initialDialog) = $event)),
      "max-width": "540",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_v_spacer),
              _cache[10] || (_cache[10] = _createTextVNode(" センサーとの疎通が完了しました。 ", -1)),
              _createVNode(_component_v_spacer)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "flat",
                onClick: _ctx.closeInitialDialog
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("確認", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_spacer)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}